export { default } from './SkeletonPackagesCarousel';
